import { useQuery } from '@tanstack/react-query';
import type { AgentApiSharedJobPostListsIndex } from '@/types/serializers';

export default function useSharedJobPostLists() {
  return useQuery<AgentApiSharedJobPostListsIndex>({
    queryKey: ['/agent/api/shared_job_post_lists'],
    queryFn: async () => {
      const response = await fetch('/agent/api/shared_job_post_lists.json');
      if (!response.ok) {
        throw new Error('Failed to fetch shared job post lists');
      }
      return response.json();
    },
  });
}
